import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import './CreateProviderModal.css';
import latinCountries from '../../utils/Countries/latin-america-countries.json';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Flag from 'react-world-flags';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser, faPhone } from '@fortawesome/free-solid-svg-icons';

const options = latinCountries.map((country) => ({
  label: (
    <div className="country-option">
      <Flag code={country.value} style={{ width: 20, height: 15, borderRadius: 2 }} />
      <span>{country.label}</span>
    </div>
  ),
  value: country.value,
  code: country.dial_code,
  example: country.example,
}));

export default function CreateProviderModal({ visible, onClose, onCreate, editData }) {
    const [name, setName] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(
        options.find(opt => opt.value === 'CO')
    );
    const [localPhone, setLocalPhone] = useState('');

    // Cargar datos cuando se está editando
    useEffect(() => {
        if (editData) {
            setName(editData.name || '');
            // Si hay teléfono en editData, intentar parsearlo
            if (editData.phone) {
                const parsed = parsePhoneNumberFromString(editData.phone);
                if (parsed) {
                    const countryCode = parsed.country;
                    const selectedOpt = options.find(opt => opt.value === countryCode);
                    if (selectedOpt) {
                        setSelectedCountry(selectedOpt);
                        setLocalPhone(parsed.nationalNumber);
                    } else {
                        setLocalPhone(editData.phone);
                    }
                } else {
                    setLocalPhone(editData.phone);
                }
            } else {
                setLocalPhone('');
            }
        } else {
            setName('');
            setLocalPhone('');
            setSelectedCountry(options.find(opt => opt.value === 'CO'));
        }
    }, [editData]);

    const isValid = () => {
        const trimmedName = name.trim();
        const trimmedLocalPhone = localPhone.trim();
        
        // Nombre mínimo 3 caracteres
        if (trimmedName.length < 3) return false;
        
        // Teléfono obligatorio y válido para el país seleccionado
        if (!selectedCountry || !trimmedLocalPhone) return false;
        
        const fullNumber = selectedCountry.dial_code + trimmedLocalPhone.replace(/^0+/, '');
        const parsed = parsePhoneNumberFromString(fullNumber, selectedCountry.value);
        
        return parsed && parsed.isValid();
    };

    const cleanData = () => {
        setName('');
        setLocalPhone('');
        setSelectedCountry(options.find(opt => opt.value === 'CO'));
    }

    const handleSubmit = () => {
        if (!isValid()) return;
        
        // Generar el teléfono en formato internacional
        const fullNumber = selectedCountry.dial_code + localPhone.trim().replace(/^0+/, '');
        const parsed = parsePhoneNumberFromString(fullNumber, selectedCountry.value);
        const internationalPhone = parsed ? parsed.number : fullNumber;
        
        onCreate({ 
            name: name.trim(), 
            phone: internationalPhone 
        });
        cleanData();
        onClose();
    };

    if (!visible) return null;

    return (
        <div className="modal-overlay-create-provider">
            <div className="modal-box">
                <div className="modal-header">
                    <h2>{editData ? 'Editar proveedor' : 'Crear proveedor'}</h2>
                    <button className="close-btn" onClick={
                        () => {
                            cleanData();
                            onClose();
                        }
                    }>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <div className="modal-body">
                    <div className="input-group">
                        <label>
                            <FontAwesomeIcon icon={faUser} className="label-icon" />
                            Nombre del proveedor
                        </label>
                        <input
                            type="text"
                            placeholder="Ej: Distribuidora Sports"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="input-group">
                        <label>
                            <FontAwesomeIcon icon={faPhone} className="label-icon" />
                            Celular
                        </label>
                        <div className='input-cellphone'>
                            <Select
                                options={options}
                                placeholder="Selecciona tu país..."
                                value={selectedCountry}
                                onChange={setSelectedCountry}
                                isSearchable
                                classNamePrefix="country"
                            />
                            <div className='cellphone-input'>
                                <span className='country-code'>
                                    {selectedCountry ? selectedCountry.code : '+57'}
                                </span>
                                <input
                                    type="text"
                                    name="localPhone"
                                    placeholder={`Ej.: ${selectedCountry?.example || '3101234567'}`}
                                    value={localPhone}
                                    onChange={(e) => setLocalPhone(e.target.value)}
                                    className='input-register'
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    className="submit-btn"
                    disabled={!isValid()}
                    onClick={handleSubmit}
                >
                    {editData ? 'Actualizar proveedor' : 'Crear proveedor'}
                </button>
            </div>
        </div>
    );
}
